/**
 * plans.js — mirror of the app's subscription catalogue.
 *
 * GENERATED from src/constants/subscriptionConfig.js (the app's source of
 * truth) — do not hand-edit. CRA forbids importing from outside admin/src, so
 * the shape is copied here rather than imported. Regenerate whenever tiers or
 * prices change.
 *
 * Plans are NOT stored in Firestore. They are in-app purchase products created
 * in the store consoles:
 *   - Google Play Console -> Monetize -> Subscriptions
 *   - App Store Connect  -> App -> In-App Purchases -> Subscriptions
 *
 * The prices below are the app's DISPLAY FALLBACK. The amount a customer is
 * actually charged always comes from StoreKit / Play Billing at runtime, so the
 * store consoles are authoritative and this tab is read-only by design.
 *
 * Last generated: 2026-08-22
 */

export const STORE_PLANS = [
  {
    "id": "paw_print",
    "name": "Paw Print",
    "accountType": "individual",
    "tagline": "Start your pet journey",
    "currency": "EUR",
    "monthly": 0,
    "yearly": 0,
    "storeProductIdMonthly": null,
    "storeProductIdYearly": null,
    "stripeProductId": null
  },
  {
    "id": "fetch",
    "name": "Fetch",
    "accountType": "individual",
    "tagline": "Most popular for pet lovers",
    "currency": "EUR",
    "monthly": 5.99,
    "yearly": 54.99,
    "storeProductIdMonthly": "com.dierend.app.fetch.monthly",
    "storeProductIdYearly": "com.dierend.app.fetch.yearly",
    "stripeProductId": "prod_ThQkyJBKTelHpP"
  },
  {
    "id": "alpha",
    "name": "Alpha",
    "accountType": "individual",
    "tagline": "Premium experience for pet enthusiasts",
    "currency": "EUR",
    "monthly": 15.99,
    "yearly": 139.99,
    "storeProductIdMonthly": "com.dierend.app.alpha.monthly",
    "storeProductIdYearly": "com.dierend.app.alpha.yearly",
    "stripeProductId": "prod_ThQnTGNuErc6oA"
  },
  {
    "id": "business_starter",
    "name": "Business Starter",
    "accountType": "business",
    "tagline": "Perfect for small pet businesses",
    "currency": "EUR",
    "monthly": 29.99,
    "yearly": 269.99,
    "storeProductIdMonthly": "com.dierend.app.business_starter.monthly",
    "storeProductIdYearly": "com.dierend.app.business_starter.yearly",
    "stripeProductId": "prod_U8HkO9MK1At1Xr"
  },
  {
    "id": "pack_leader",
    "name": "Pack Leader",
    "accountType": "business",
    "tagline": "Complete solution for pet businesses",
    "currency": "EUR",
    "monthly": 59.99,
    "yearly": 549.99,
    "storeProductIdMonthly": "com.dierend.app.pack_leader.monthly",
    "storeProductIdYearly": "com.dierend.app.pack_leader.yearly",
    "stripeProductId": "prod_ThQo0yCbSpAT3Z"
  },
  {
    "id": "vet_pro",
    "name": "Vet Pro",
    "accountType": "veterinary",
    "tagline": "Complete veterinary practice solution",
    "currency": "EUR",
    "monthly": 47.99,
    "yearly": 434.99,
    "storeProductIdMonthly": "com.dierend.app.vet_pro.monthly",
    "storeProductIdYearly": "com.dierend.app.vet_pro.yearly",
    "stripeProductId": "prod_ThQpvU0XAPRcAr"
  },
  {
    "id": "vet_duo",
    "name": "Vet Duo",
    "accountType": "veterinary",
    "tagline": "Veterinary duo practice solution",
    "currency": "EUR",
    "monthly": 69.99,
    "yearly": 649.99,
    "storeProductIdMonthly": "com.dierend.app.vet_duo.monthly",
    "storeProductIdYearly": "com.dierend.app.vet_duo.yearly",
    "stripeProductId": "prod_TBD_vet_duo"
  },
  {
    "id": "vet_team",
    "name": "Vet Team",
    "accountType": "veterinary",
    "tagline": "Veterinary team practice solution",
    "currency": "EUR",
    "monthly": 149.99,
    "yearly": 899.99,
    "storeProductIdMonthly": "com.dierend.app.vet_team.monthly",
    "storeProductIdYearly": "com.dierend.app.vet_team.yearly",
    "stripeProductId": "prod_TBD_vet_team"
  }
];

export default STORE_PLANS;
